<div class="box relative">
    <app-loader *ngIf="searching" loaderColor="default" loaderType="cover" overlayColor="white"></app-loader>

    <div class="h-100 relative inner">
        <div class="table-flex table-softer rounded o-hidden" [ngClass]="{ 'table-scroll': scrollbarYEnabled }">
            <div class="thead bg-softer">
                <div class="trow">
                    <div class="tcell small"></div>
                    <div class="tcell grow text-xs font-semi-bold text-muted" translate>v3-byoc-popup-create-mission-course-table-course-name</div>
                    <div class="tcell small"></div>
                </div>
            </div>
            <div #ps class="tbody" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }" (psYReachEnd)="psYReachEnd()">
                <div class="trow" *ngFor="let newCourse of newlyCreatedCourses" [formGroup]="coursesFormGroup">
                    <div class="tcell center small">
                        <app-form-checkbox
                            *ngIf="!searching"
                            [label]=""
                            classes="text-xxs text-uppercase text-oneline pe-4 w-100"
                            [controlName]="newCourse.id"
                            [formControlDataTest]="newCourse.id"
                        ></app-form-checkbox>
                    </div>
                    <div class="tcell grow text-xs font-semi-bold">{{ newCourse.name }}</div>
                </div>

                <div class="trow" *ngFor="let course of coursesList" [formGroup]="coursesFormGroup">
                    <div class="tcell center small">
                        <app-form-checkbox
                            *ngIf="!searching"
                            [label]=""
                            classes="text-xxs text-uppercase text-oneline pe-4 w-100"
                            [controlName]="course.id"
                            [formControlDataTest]="course.id"
                        ></app-form-checkbox>
                    </div>
                    <div *ngIf="!isCourseInactive(course); else inactiveCourseLink" class="tcell grow text-xs font-semi-bold">
                        <a [routerLink]="['/library', 'course', course.id]" [target]="'_blank'" class="pointer">
                            <span class="text-hover-info">
                                {{ course.name }}
                            </span>
                        </a>
                    </div>
                    <ng-template #inactiveCourseLink>
                        <div class="tcell grow text-xs font-semi-bold">
                            <span>
                                {{ course.name }}
                            </span>
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="noResults" class="py-5 font-semi-bold text-xs text-center" translate>v3-byoc-popup-create-mission-course-table-empty</div>
            </div>
        </div>
    </div>
</div>
